import {Component, inject} from '@angular/core';
import {copyToClipboard} from "@app/shared/helpers";
import {TranslateModule} from "@ngx-translate/core";
import {NzTooltipDirective} from "ng-zorro-antd/tooltip";
import {AppStateService} from "@app/shared/services/app-state.service";

@Component({
  selector: 'sf-coupon-banner',
  imports: [
    NzTooltipDirective,
    TranslateModule
  ],
  templateUrl: './coupon-banner.component.html',
  styleUrl: './coupon-banner.component.scss'
})
export class CouponBannerComponent {
  protected readonly appStateService = inject(AppStateService);

  public couponCopiedState = false;

  constructor() {
  }

  protected copyCoupon() {
    copyToClipboard(this.appStateService.user!.referAndEarn.coupon);
    this.couponCopiedState = true;

    setTimeout(() => this.couponCopiedState = false, 3000);
  }

}
